'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function SKFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-mr9si8waq", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-6r0q79i2a", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-ax4sy2mgq" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-n3owjrzw4", fill: "#fff" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M9.873 7.04c.18-1.295.09-3.632-.27-7.01H.346C.1 3.652.048 5.99.188 7.04c.21 1.578 1.163 5.042 4.79 6.608 3.461-1.547 4.626-4.664 4.895-6.607z"
      }
    )), /* @__PURE__ */ React.createElement("path", { id: "mantine-ax4sy2mgq", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-mr9si8waq)" }, /* @__PURE__ */ React.createElement("use", { fill: "#3d58db", xlinkHref: "#mantine-ax4sy2mgq" }), /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M0 0h32v8H0z", mask: "url(#mantine-6r0q79i2a)" }), /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M0 16h32v8H0z", mask: "url(#mantine-6r0q79i2a)" }), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-6r0q79i2a)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        stroke: "#fff",
        d: "M16.053 5.53c.406 3.679.506 6.205.316 7.58-.286 2.058-1.522 5.356-5.187 6.995-4.245-1.658-5.266-5.324-5.49-6.998-.147-1.111-.09-3.636.186-7.577z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f7fcff",
        d: "M4.257.59c.138.21.237.475.299.795s.098.763.108 1.324l-1.958-.24v1.485l2.002-.255-.032 1.41a4.79 4.79 0 01-1.09 0c-.328-.042-.815-.15-1.46-.323v1.7c.655-.21 1.142-.338 1.46-.386a4.12 4.12 0 011.09 0v2.088h.813V6.1c.592-.052 1.065-.05 1.419.006.353.056.697.182 1.033.38v-1.7c-.34.17-.67.275-.99.317-.32.042-.808.044-1.462.005l.032-1.41c.444-.045.79-.051 1.039-.018.248.034.529.125.84.274V2.468c-.304.165-.575.263-.814.293-.238.03-.608.013-1.109-.052.01-.58.04-1.01.09-1.293A2.77 2.77 0 015.863.59z",
        mask: "url(#mantine-n3owjrzw4)",
        transform: "translate(6 6)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#2e42a5",
        d: "M.897 10.245c.293-.629.678-1.003 1.155-1.122.477-.12.965.067 1.465.561.305-.998.83-1.496 1.574-1.496s1.247.498 1.508 1.496c.317-.374.704-.561 1.16-.561s.897.374 1.32 1.122c-1.364 2.476-2.727 3.714-4.09 3.714S2.26 12.72.896 10.245z",
        mask: "url(#mantine-n3owjrzw4)",
        transform: "translate(6 6)"
      }
    ))))
  );
}

export { SKFlag };
//# sourceMappingURL=SK.mjs.map
